import React from 'react';
import BookContent from "../components/BookPage/BookContent";

const BookPage = () => {
    return (
        <div>
            <BookContent/>
        </div>
    );
};

export default BookPage;